import React from "react";
import PropTypes from "prop-types";
import SharedToolTip from "../sharedToolTip/SharedToolTip";
import EMPEmptyState from "../components/EMPEmptyState/EMPEmptyState";
import { Typography, Grid, Box } from "@mui/material";

const CHARS_PER_LINE = 75;

const TextWrap = ({ lines }) => {
  return lines.map((line) => (
    <Box key={line} sx={{ padding: 2 }}>
      {line}
    </Box>
  ));
};

TextWrap.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export const StyledTableRow = (props) => {
  const { text, data, testID } = props;

  const splitIntoLines = (rowText) => {
    if (!rowText || rowText.length < CHARS_PER_LINE) return [rowText];

    const wordArr = rowText.split(" ");
    const lines = [];
    let currLine = "";

    while (wordArr.length) {
      if (currLine.length + wordArr[0].length <= CHARS_PER_LINE) {
        currLine += ` ${wordArr.shift()}`;
      } else {
        lines.push(currLine);
        currLine = "";
      }
    }

    if (currLine.length) lines.push(currLine);

    return lines;
  };

  const lines = splitIntoLines(text);

  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item>
        <TextWrap lines={lines} />
        {props.tooltip && (
          <SharedToolTip
            openTestid={props.tooltip.openTestid}
            closeTestid={props.tooltip.closeTestid}
            title={props.tooltip.title}
            body={props.tooltip.body}
          />
        )}
      </Grid>
      {data === undefined ? null : (
        <Grid item data-testid={testID}>
          <Box sx={{ padding: 2 }}>
            {data === null ? <EMPEmptyState /> : data}
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

StyledTableRow.propTypes = {
  text: PropTypes.string.isRequired,
  data: PropTypes.node,
  testID: PropTypes.string,
  tooltip: PropTypes.shape({
    openTestid: PropTypes.string,
    closeTestid: PropTypes.string,
    title: PropTypes.string,
    body: PropTypes.string,
  }),
};

StyledTableRow.defaultProps = {
  data: undefined,
  testID: undefined,
  tooltip: null,
};

export const StyledBigTableHeader = ({ text, data, testID }) => {
  return (
    <Grid container alignItems="center">
      <Grid item xs={8}>
        <Typography variant="h5">{text}</Typography>
      </Grid>
      <Grid item xs={4} data-testid={testID}>
        {data === null ? (
          <EMPEmptyState />
        ) : (
          <Typography variant="h5" textAlign="right">
            {data}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

StyledBigTableHeader.propTypes = {
  text: PropTypes.string.isRequired,
  data: PropTypes.node,
  testID: PropTypes.string,
};

StyledBigTableHeader.defaultProps = {
  data: null,
  testID: undefined,
};

export const StyledTableHeader = ({ text, data, testID }) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      sx={{ my: 4 }}
    >
      <Grid item>
        <Typography variant="subtitle1">{text}</Typography>
      </Grid>
      <Grid item data-testid={testID}>
        {data === null ? (
          <EMPEmptyState />
        ) : (
          <Typography variant="subtitle1">{data}</Typography>
        )}
      </Grid>
    </Grid>
  );
};

StyledTableHeader.propTypes = {
  text: PropTypes.string.isRequired,
  data: PropTypes.node,
  testID: PropTypes.string,
};

StyledTableHeader.defaultProps = {
  data: null,
  testID: undefined,
};
